/* Kkumi email signup — custom double opt-in. Posts the email (+ optional bias/
   group) to the rewards worker's App Proxy endpoint, which sends a branded
   confirmation email. NO Shopify customer is created and NOTHING is subscribed
   until the recipient clicks the confirm link. Per-instance config comes from
   <script type="application/json" data-kkumi-signup-config>. */
(function () {
  var ENDPOINT = '/apps/rewards/subscribe-request';

  function initInstance(cfg) {
    var FORM_ID = cfg.formId || '';
    var SUCCESS_ID = cfg.successId || '';
    var SOURCE = cfg.source || 'Footer Signup';
    var ERR_RATE_LIMITED = cfg.errorRateLimited || 'Too many tries. Give it a minute and try again.';
    var ERR_GENERIC = cfg.errorGeneric || "That didn't go through. Check your email and try again.";
    var ERR_NETWORK = cfg.errorNetwork || 'Network hiccup. Give it another go.';

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      var form = document.getElementById(FORM_ID);
      if (!form) return;
      var section = form.closest('.kkumi-signup');
      // A subscribed customer may still need the explicit Club join door.
      // Reveal only on deliberate navigation; never submit or change consent.
      function revealJoinTarget() {
        if (!section || location.hash !== '#' + section.id) return;
        section.hidden = false;
        section.scrollIntoView({ block: 'start' });
        var emailInput = form.querySelector('[name="email"]');
        if (emailInput) emailInput.focus({ preventScroll: true });
      }
      window.addEventListener('hashchange', revealJoinTarget);
      revealJoinTarget();
      if (cfg.hideForMembers && section && window.KKRewards) {
        window.KKRewards.get('/balance', { scope: 'member' }).then(function (balance) {
          if (balance && balance.club_member === true && location.hash !== '#' + section.id &&
              !section.contains(document.activeElement)) section.hidden = true;
        }).catch(function () { /* Keep the join door visible if membership is unknown. */ });
      }
      var success = document.getElementById(SUCCESS_ID);
      var errorEl = form.querySelector('[data-signup-error]');

      function value(name) {
        var el = form.querySelector('[name="' + name + '"]');
        return el ? el.value.trim() : '';
      }
      function groupValues() {
        var el = form.querySelector('[name="group"]');
        // Multistans: pull the chip array if the multi typeahead is active,
        // otherwise fall through to the single-input value.
        if (el && window.KkumiGroups) {
          var arr = window.KkumiGroups.read(el);
          if (arr.length) return arr;
        }
        var v = value('group');
        return v ? [v] : [];
      }
      function showError(msg) {
        if (!errorEl) return;
        errorEl.hidden = false;
        errorEl.textContent = msg;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = value('email');
        if (!email) return;
        form.classList.add('is-submitting');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // `offer`: the welcome offer this visitor was shown (snippets/kkumi-welcome-offer.liquid),
          // so their welcome email carries that gift.
          body: JSON.stringify({ email: email, bias: value('bias'), groups: groupValues(), source: SOURCE, offer: (window.KKOffer && window.KKOffer.arm) || null })
        }).then(function (res) {
          form.classList.remove('is-submitting');
          if (res.ok) {
            form.classList.add('is-success');
            // Also on the section root: the spent lede sits OUTSIDE the form,
            // so the form's own class can't reach it (kkumi-email-signup.liquid).
            var section = form.closest ? form.closest('.kkumi-signup') : null;
            if (section) section.classList.add('is-success');
            if (success) {
              success.hidden = false;
              // role="status" alone is unreliable for content that was already
              // in the DOM and merely unhidden — move focus so it's announced.
              try { success.focus(); } catch (e) {}
            }
            return;
          }
          showError(res.status === 429 ? ERR_RATE_LIMITED : ERR_GENERIC);
        }).catch(function () {
          form.classList.remove('is-submitting');
          showError(ERR_NETWORK);
        });
      });
    });
  }

  document.querySelectorAll('script[data-kkumi-signup-config]').forEach(function (el) {
    if (el.dataset.kkumiInit === '1') return;
    el.dataset.kkumiInit = '1';
    try { initInstance(JSON.parse(el.textContent)); } catch (e) {
      console.error('[Kkumi signup] bad config JSON', e);
    }
  });
})();
